import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import './mouse';
import './keyboard';
import './window';
import './exporter';

createApp(App).mount('#app');
